export default "__VITE_ASSET__VobqYQ4o__"